import { AttackPattern, PatternState } from '../AttackPattern.js';
import { Ostinato } from './Ostinato.js';
import { Understudy } from './Understudy.js';

/**
 * The Last Verse — The Anthem's desperation finale (Act III-6, ACT3-BIBLE §3).
 *
 * Every other desperation in the game is the boss's last, biggest attack. This
 * one is the opposite and that is the whole point: the Anthem has stopped
 * attacking. It is simply *finishing the song*. What you have to survive is
 * everything the act made out of you — every mirrored weapon, both bodies, your
 * entire replayed path — running at once against a boss that is no longer
 * participating.
 *
 * Mechanically that means: no ring, no volley of its own, the children driven
 * flat out with their escalations forced on regardless of phase. The threat is
 * entirely the player's own build, history, and second body, which is the last
 * thing the act has left to say.
 */
export class TheLastVerse extends AttackPattern {
  constructor({ config }) {
    super({ name: 'The Last Verse', telegraphDuration: 1.4, activeDuration: 6.0, minPhase: 0 });
    this.config = config;
    this.combat = null;
    this._children = [];
  }

  onBegin(boss, player) {
    this._children = [
      // strettoPhase/curtainCallPhase at 0 so both escalations are live from
      // the first frame — there is no "later" left to hold them for.
      new Ostinato({ minPhase: 0, config: { ...this.config.ostinato, strettoPhase: 0 } }),
      new Understudy({ minPhase: 0, config: { ...this.config.understudy, curtainCallPhase: 0 } }),
    ];
    for (const child of this._children) {
      if ('combat' in child) child.combat = this.combat;
      child.begin(boss, player);
    }
  }

  onActiveTick(dt, boss, player, pool) {
    for (const child of this._children) {
      pool.sourceLabel = child.name;
      child.update(dt, boss, player, pool);
      if (child.isDone) child.begin(boss, player);
    }
    pool.sourceLabel = this.name;
  }

  onEnd() {
    this._children = [];
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH && this.state !== PatternState.ACTIVE) return null;
    return { kind: 'composite', children: this._children.map((c) => c.getVisual(boss)).filter(Boolean) };
  }
}
